export default __webpack_public_path__ + "files/historical-19717b301b6c17f59627609ca8667b77.png";